module.exports = __webpack_public_path__ + "img/icon-floorplan.6a2b7ecf.svg";